// extracted by css-extract-rspack-plugin
export default {"container":"Ripple-module__container","rippleSpan":"Ripple-module__rippleSpan","ripple":"Ripple-module__ripple","darkBlack":"Ripple-module__darkBlack"};